const getOrganizationColors = (organization?: string) => {
  switch (organization?.toLocaleLowerCase()) {
    case "comcast":
      return ["#FCCC14", "#FF7112", "#EF1541", "#FF01E8", "#6E55DC", "#069DE0", "#00DABD", "#05AC3F", "#1d1d1b", "#ffffff"];
    case "rtx":
      return ["#000000", "#ffffff", "#D9D9D6", "#B1B3B3", "#63666A"];
    case "synopsys":
    case "synopsys private workspace":
      return ["#000000", "#ffffff", "#5A2A82", "#7E45AF", "#0081FE", "#00A5A8", "#79A133", "#26874D", "#FDB71A", "#E37820"];
    case "target":
      return ["#CC0000", "#333333", "#ffffff"];
    case "premise health":
      return ["#FFFFFF", "#000000", "#1C75BC", "#62CEC4", "#ED1C24", "#F7941D", "#FFC56E", "#858585", "#00568C", "#00A79D", "#CE3F29", "#DC582A", "#FBB040", "#4A4A4A"];
    default:
      return [];
  }
};

export default getOrganizationColors;
